import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import PrivateIcon from '@wix/da-ds/pkg/Icons/16x16/Private';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  /** don't display language after stat count */
  onlyNumbers?: boolean;
}

const PrivateCollectionStat: React.FC<Props> = ({
  deviation,
  onlyNumbers,
  className,
}) => {
  const { t } = useTranslation();
  const { privatelyCollected } = useDeviationStats(deviation);

  if (!privatelyCollected) {
    return null;
  }

  return (
    <Stat
      className={className}
      deviation={deviation}
      icon={PrivateIcon}
      statNameLocaleKey="deviation.stats.privateCollections"
      statCount={privatelyCollected}
      onlyNumbers={onlyNumbers}
      title={t('deviation.stats.tooltip.privateCollections')}
    />
  );
};
PrivateCollectionStat.displayName = 'PrivateCollectionStat';

export default PrivateCollectionStat;
